import React from 'react';
import mime from 'mime-types';
import ButtonAction from '../ButtonAction';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';

const ButtonViewFile = ({fileExtension, onClick}) => {
  const getType = () => {
    switch (fileExtension) {
      case 'pdf':
      case 'PDF':
        return 'pdf';
      case 'gif':
      case 'jpeg':
      case 'jpg':
      case 'tiff':
      case 'png':
        return 'image';
      default:
        return null;
    }
  };

  const updateFile = async () => {
    try {
      const body = await onClick();
      const mimeType = mime.lookup(fileExtension);
      return Boolean(body) ? `data:${mimeType};base64,${body}` : null;
    } catch (e) {
      console.error(e);
    }
  };

  const handleOpen = () => {
    if (getType()) {
      Promise.resolve()
        .then(updateFile)
        .then((content) => {
          if (content) {
            let file = getType() === 'image'
              ? '<img src="' + content + '">'
              : '<iframe width="100%" height="100%" src="' + content + '"></iframe>';
            let popup = window.open();
            popup.document.write(file);
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  };

  return (
    <ButtonAction
      variant={'icon'}
      iconButtonType={'success'}
      label={
        <img
          src={toAbsoluteUrl('/media/common/Eye_green.svg')}
          alt="preview"
        />
      }
      onClick={() => handleOpen()}
    />
  );
};

export default ButtonViewFile;
